import { h } from 'hyperapp';
import { Range } from './front_component';

const GRATRA_HEIGHT = 5

export const prepareTextAsync = async (args) => {
  return new Promise(resolve => {
    const myK = (result) => {resolve(result)}
    prepareText(args, myK)
  })
}

export const prepareText = ({offscreenId, name, value, point}, k) => {
  const offscreen = document.getElementById(offscreenId)
  window.requestAnimationFrame(() => {
    const ctx = offscreen.getContext('2d')
    const paperWidth = offscreen.width
    const paperHeight = offscreen.height
  
    const lines = value.text.split('\n')
    const sizes = {'S':14, 'MS':18, 'M':24, 'ML':30, 'L':42}

    const size = sizes[value.size]
    const lineHeight = Math.ceil(size * 1.5)
    const height = lineHeight * lines.length
    const cx = Math.round(point.x * 0.01 * paperWidth)
    const cy = Math.round(point.y * 0.01 * paperHeight)
    const by = Math.round(cy - 0.5 * height)
  
    ctx.clearRect(0, 0, paperWidth, paperHeight)
    ctx.font = `${sizes[value.size]}px sans-serif`
    ctx.textAlign = 'center'
    ctx.fillStyle = value.color
    for (let i = 0; i < lines.length; i++) {
      ctx.fillText(lines[i], cx, by + i * lineHeight)
    }
    offscreen.toBlob((blob) => {
      k({name, blob})
    })
  })
}

export const preparePictureAsync = async (args) => {
  return new Promise(resolve => {
    const myK = (result) => {resolve(result)}
    preparePicture(args, myK)
  })
}

export const preparePicture = ({offscreenId, name, imageUrl, x, y, scale, frame}, k) => {
  // scale: 描画枠の幅を1とする。
  // x, y: 描画枠・オリジナル画像それぞれの中心を原点とし、そこからのオフセット。コーディネートは表示大(px)
  const offscreen = document.getElementById(offscreenId)
  const image = new window.Image()
  image.addEventListener('load', (ev) => {
    const ctx = offscreen.getContext('2d')
    const paperWidth = offscreen.width
    const paperHeight = offscreen.height
    const baseScale = ((frame.right - frame.left) * 0.01 * paperWidth) / image.naturalWidth
    const actualScale = scale * baseScale  // 原寸大(px)から表示大(px)へのスケール
    
    const sx = 0
    const sy = 0
    const sw = image.naturalWidth
    const sh = image.naturalHeight
    const dx = Math.round(((frame.left + frame.right) * 0.5 * 0.01 * paperWidth) - image.naturalWidth * 0.5 * actualScale + x)
    const dy = Math.round(((frame.top + frame.bottom) * 0.5 * 0.01 * paperHeight) - image.naturalHeight * 0.5 * actualScale + y)
    const dw = Math.round(image.naturalWidth * actualScale)
    const dh = Math.round(image.naturalHeight * actualScale)
    const fyt = Math.round(frame.top * paperHeight / 100)
    const fyb = Math.round(frame.bottom * paperHeight / 100)
    const fxl = Math.round(frame.left * paperWidth / 100)
    const fxr = Math.round(frame.right * paperWidth / 100)
    const fw = fxr - fxl
    const fh = fyb - fyt

    ctx.save()
    ctx.clearRect(0, 0, paperWidth, paperHeight)
    ctx.beginPath()
    ctx.rect(fxl, fyt, fw, fh)
    ctx.clip()
    ctx.drawImage(image, sx, sy, sw, sh, dx, dy, dw, dh)

    if (frame.gratra) {
      const imageData = ctx.getImageData(fxl, fyt, fw, fh)
      const gratraHeight = Math.round(GRATRA_HEIGHT * 0.01 * paperHeight)
      for (let i = 0; i < gratraHeight; i++) {
        const y = fh - i - 1
        const d = (i + 1) / (gratraHeight + 1)
        const alpha = Math.round(d * 256)
        for (let x = 0; x < imageData.width; x++) {
          const index = y * imageData.width * 4 + x * 4 + 3
          imageData.data[index] = alpha
        }
      }
      ctx.putImageData(imageData, fxl, fyt)
    }
    ctx.restore()

    offscreen.toBlob((blob) => {
      k({name, x, y, scale, blob})
    })
  })
  image.src = imageUrl
}

export const Imagecrop = ({name, imageUrl, x, y, scale, paperWidth, paperHeight, frame, oncropend, offscreenId}) => {
  let canvas = null
  let image = null
  let drag = null
  const commit = () => {
    if (! canvas || ! image) return

    preparePicture({offscreenId, name, imageUrl, x, y, scale, frame}, oncropend)
  }
  const oncreate = (el) => {
    canvas = el.querySelector('.rd--canvas')
    canvas.addEventListener('mousedown', ondragstart)
    canvas.addEventListener('touchstart', ondragstart)
    canvas.addEventListener('mousemove', ondrag)
    canvas.addEventListener('touchmove', ondrag)
    canvas.addEventListener('mouseout', ondragend)
    canvas.addEventListener('mouseup', ondragend)
    canvas.addEventListener('touchend', ondragend)
    let range = el.querySelector('input')
    range.addEventListener('change', onchange)
    range.addEventListener('input', onchange)
    image = new window.Image()
    image.addEventListener('load', draw)
    image.src = imageUrl
  }
  const ondestroy = (el) => {
    if (! canvas) return
    canvas = null
  }
  const ondragstart = (ev) => {
    drag = {x:ev.pageX, y:ev.pageY}
    return false
  }
  const ondrag = (ev) => {
    if (! drag) return
    const x0 = x + ev.pageX - drag.x
    const y0 = y + ev.pageY - drag.y
    draw(x0, y0)
    return false
  }
  const ondragend = (ev) => {
    if (! drag) return
    x += ev.pageX - drag.x
    y += ev.pageY - drag.y
    drag = null
    draw()
    return false
  }
  const onchange = (ev) => {
    const scale0 = ev.currentTarget.value
    if (scale0 * 0.01 != scale) {
      scale = scale0 * 0.01
      draw()
    }
  }
  const draw = (x0, y0) => {
    if (! canvas || ! image) return

    if (typeof x0 != 'number') x0 = x
    if (typeof y0 != 'number') y0 = y
    
    const ctx = canvas.getContext('2d')

    ctx.fillStyle = 'rgb(255,255,255)'
    ctx.fillRect(0, 0, paperWidth, paperHeight)

    const baseScale = ((frame.right - frame.left) * 0.01 * paperWidth) / image.naturalWidth
    const actualScale = scale * baseScale  // 原寸大(px)から表示大(px)へのスケール

    const sx = 0
    const sy = 0
    const sw = image.naturalWidth
    const sh = image.naturalHeight
    const dx = ((frame.left + frame.right) * 0.5 * 0.01 * paperWidth) - image.naturalWidth * 0.5 * actualScale + x0
    const dy = ((frame.top + frame.bottom) * 0.5 * 0.01 * paperHeight) - image.naturalHeight * 0.5 * actualScale + y0
    const dw = image.naturalWidth * actualScale
    const dh = image.naturalHeight * actualScale
    ctx.drawImage(image, sx, sy, sw, sh, dx, dy, dw, dh)

    /*ctx.fillStyle = 'rgba(200,200,255,0.4)'
    const fyt = frame.top * paperHeight / 100
    const fyb = frame.bottom * paperHeight / 100
    const fxl = frame.left * paperWidth / 100
    const fxr = frame.right * paperWidth / 100
    ctx.fillRect(0, 0, paperWidth, fyt)
    ctx.fillRect(0, fyb, paperWidth, paperHeight - fyb)
    ctx.fillRect(0, fyt, fxl, fyb - fyt)
    ctx.fillRect(fxr, fyt, paperWidth - fxr, fyb - fyt)*/

    ctx.fillStyle = 'rgba(0,0,0,0.4)'
    const fyt = frame.top * paperHeight / 100
    const fyb = frame.bottom * paperHeight / 100
    const fxl = frame.left * paperWidth / 100
    const fxr = frame.right * paperWidth / 100
    ctx.fillRect(fxl, fyt, fxr - fxl, fyb - fyt)
  }
  return [(
    <div class="rd-Imagecrop" oncreate={oncreate} ondestroy={ondestroy} >
      <Range name="range" min="10" max="200" step={1} value={scale * 100} oninput={null} onchange={null} suffix="x" xclass="rd-belongs-Imagecrop" />
      <canvas class="rd--canvas" width={paperWidth} height={paperHeight}></canvas>
    </div>
  ), commit]
}
